import React, { FC, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeading } from "../../Components/page-heading.component";
import styles from "./Contact.module.scss";
import ContactDetail from "./ContactDetail/ContactDetail";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import { ContactService } from "../../Services/contact.service";
import { GetAllDto } from "../../Shared/dto/get-all-dto";
import threedots from "../../assets/images/threedots.svg";
import { useLoading } from "../../Shared/services/loading-context";
import { useSnackbar } from "notistack";

interface ContactProps {}

const Contact: FC<ContactProps> = () => {
  const [contactData, setContactData] = useState<any[]>([]);
  const [anchorE2, setAnchorE2] = React.useState<null | HTMLElement>(null);
  const [actionToggle, setActionToggle] = useState<any>(false);
  const [rowValue, setRowValue] = useState<any>();
  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const ContactDetail = () => {
    navigate("/contact/contactDetail");
  };
  const { loading, setLoading } = useLoading();

  const getContactData = async (searchQuery?: string) => {
    const getAllDto = new GetAllDto("name");
    if (searchQuery) {
      getAllDto.searchQuery = searchQuery;
    }
    setLoading(true);
    const response = await ContactService.getContacts(getAllDto);
    setLoading(false);
    if (response.success) {
      setContactData(response.data);
    } else
      enqueueSnackbar(response.message ?? "Internal server error", {
        variant: "error",
      });
  };

  useEffect(() => {
    // getContactData();
  }, []);

  const handleCloseEditDelete = () => {
    setActionToggle(false);
  };

  const handleEdit = () => {
    navigate(`/contactDetail/${rowValue}`);
  };
  const handleView = (id:number) => {
    navigate(`/contact-view/${id}`);
  };

  const editDeleteDropdown = (
    event: React.MouseEvent<HTMLButtonElement>,
    currElemId: any
  ) => {
    setRowValue(currElemId);
    setAnchorE2(event.currentTarget);
    setActionToggle(true);
  };

  return (
    <div>
      <PageHeading
        title="Contact"
        addNew={ContactDetail}
        hasFilter={true}
        onSearch={getContactData}
      />
      {contactData.map((currElem, index) => {
  return (
    <Box
      key={currElem.id || index}
      className="sales-list d-flex justify-content-between"
    >
      <div onClick={() => handleView(currElem.id)}>
        <span className="sales-serialnum"></span>
        <span className="sales-date"></span>
      </div>

      <div className="sales-name-contact-grid" onClick={() => handleView(currElem.id)}>
        <span className="sales-listname">{currElem.name}</span>
        <span className="sales-listcontact">{currElem.mobileNo}</span>
      </div>

      <div className="sales-listname" onClick={() => handleView(currElem.id)}>
        {currElem.contactType}
      </div>

      <div onClick={() => handleView(currElem.id)}>
        <span className="sales-amount-first">
          {currElem.sourceOfPromotion}
        </span>
        {/* <span className="sales-amount-second">₹21234321</span> */}
      </div>

      <>
        <Button
          className="threeDots"
          onClick={(e) => editDeleteDropdown(e, currElem.id)}
        >
          <img src={threedots} alt="Menu" />
        </Button>

        <Menu
          anchorEl={anchorE2}
          open={actionToggle}
          onClose={handleCloseEditDelete}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem key={currElem.id + "_edit"} onClick={handleEdit}>
            Edit
          </MenuItem>
          <MenuItem key={currElem.id + "_delete"}>Delete</MenuItem>
        </Menu>
      </>
    </Box>
  );
})}

    </div>
  );
};

export default Contact;
